import { useNavigate } from 'react-router-dom'

export function DashboardIssueWithDocs() {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              onClick={() => navigate('/readyCloud')} 
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p className='text-2xl'>Re-print Documents</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <p className='font-bold text-xl text-center'>It looks like there was a little hiccup with your documents. Please click the button above to generate a new shipping label and re-send your SETC Packet.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>We noticed a small issue with your documents and kindly ask that you reprint and send them to us again. You can print your documents <span onClick={() => navigate('/readyCloud')} className='font-bold text-[#FF8C00] underline'>HERE.</span></p>
        <p className='font-bold text-xl text-[#646464]'>A new QR code has been generated for you - simply bring it in to your nearest UPS Store, and they'll help you send your packet back. Thank you for your cooperation!</p>
      </div>
    </div>
  )
}